export const body = {
    textAlign: "left",
    cursor: "pointer"
};
